import type { IssPass } from '../../../shared/domain/index.ts';

const COMPASS = ['nord', 'nord-est', 'est', 'sud-est', 'sud', 'sud-ouest', 'ouest', 'nord-ouest'];

/** « du sud-ouest vers le nord-est » : l'azimut seul ne parle à personne. */
export function direction(azimuthDeg: number): string {
  return COMPASS[Math.round(azimuthDeg / 45) % 8] ?? 'horizon';
}

export function passDuration(pass: IssPass): string {
  const minutes = Math.floor(pass.durationS / 60);
  const seconds = pass.durationS % 60;
  if (minutes === 0) return `${seconds} s`;
  return seconds === 0 ? `${minutes} min` : `${minutes} min ${seconds} s`;
}
